module.exports = __webpack_public_path__ + "img/SKMA_rules6.fe229b17.png";